import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { environment } from '~environments/environment';

export interface PhraseLoaderConfig {
  locales: object;
  token: string;
  url: string;
}

export class I18nLoader extends TranslateHttpLoader {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly platformId: string
  ) {
    super(httpClient);
  }

  private getPhraseTranslations(lang: string): Observable<object> {
    const localeFile = `/assets/i18n/${lang}.json`;

    let filePath = this.httpClient.get(localeFile);

    if (!isPlatformBrowser(this.platformId)) {
      filePath = this.httpClient.get(
        environment.applications.front.url + localeFile
      );
    }

    return filePath;
  }

  private getRoutes(lang: string): Observable<object> {
    let base$ = this.httpClient.get(`/assets/routes/${lang}.json`);

    // in SSR, no relative url
    if (!isPlatformBrowser(this.platformId)) {
      base$ = this.httpClient.get(
        `${environment.applications.front.url}/assets/routes/${lang}.json`
      );
    }
    return base$.pipe(
      map((routes) => {
        return {
          ROUTES: routes,
        };
      })
    );
  }

  public getTranslation(lang: string): Observable<object> {
    return this.getPhraseTranslations(lang).pipe(
      mergeMap((translations) => {
        return this.getRoutes(lang).pipe(
          map((routes) => {
            return {
              ...translations,
              ...routes,
            };
          })
        );
      })
    );
  }
}
